import { memo } from 'react';

import { GPTBanner } from './GPTBanner';
import { useApiContext } from 'react-easyrocket';
import { GPTBannerHeadless, GPTBannersContainer } from 'src/EXPERIMENTAL_LIB/gpt/banners';
import { useDrawer } from 'src/hooks/useDrawer';
import classNames from 'classnames';
import { isShowEvent } from 'src/config/event/utils';
import { LuckyPigeonEventIcon } from 'src/config/assets/gptEventIcons/LuckyPigeonEventIcon';
import { LuckyCardEventIcon } from 'src/config/assets/gptEventIcons/LuckyCardEventIcon';
import { WheelOfFortuneEventIcon } from 'src/config/assets/gptEventIcons/WheelOfFortuneEventIcon';

export const GPTBanners = memo(function GPTBanners() {
  const { isLeftDrawerOpen } = useDrawer();
  const { isAuthenticated } = useApiContext();

  if (!isAuthenticated) return null;

  const isLuckyCardEvent = isShowEvent('LUCKY_CARD');
  const isGptGamesEvent = isShowEvent('GPT_GAMES');
  const isSpinAdditional = isShowEvent('SPIN_ADDITIONAL');

  const isShowLuckyCardBanner = (() => {
    if (isGptGamesEvent) {
      return isLuckyCardEvent;
    }
    return true;
  })();

  const wheelOfFortuneEventTitle = (() => {
    return isSpinAdditional
      ? 'gpt.wheelOfFortuneBannerEventAdditionalTitle'
      : 'gpt.wheelOfFortuneBannerEventTitle';
  })();

  return (
    <GPTBannersContainer>
      <div
        className={classNames(
          isLeftDrawerOpen && 'blur-sm',
          'fixed bottom-44 right-4 z-[699] flex flex-col items-end gap-4 1024:bottom-1/2 1024:translate-y-1/2'
        )}>
        {isShowLuckyCardBanner ? (
          <GPTBannerHeadless
            gameName="cardGame"
            renderBanner={({ Icon, ...props }) => (
              <GPTBanner {...props} Icon={isGptGamesEvent ? LuckyCardEventIcon : Icon} />
            )}
            key="cardGame"
          />
        ) : (
          <GPTBannerHeadless
            gameName="birdGame"
            renderBanner={({ Icon, title, ...props }) => (
              <GPTBanner
                {...props}
                Icon={isGptGamesEvent ? LuckyPigeonEventIcon : Icon}
                title={isGptGamesEvent ? 'gpt.luckyPigeonBannerEventTitle' : title}
              />
            )}
            key="birdGame"
          />
        )}
        <GPTBannerHeadless
          gameName="wheelOfFortune"
          renderBanner={({ Icon, title, ...props }) => (
            <GPTBanner
              {...props}
              Icon={isGptGamesEvent ? WheelOfFortuneEventIcon : Icon}
              title={isGptGamesEvent ? wheelOfFortuneEventTitle : title}
            />
          )}
          key="wheelOfFortune"
        />
      </div>
    </GPTBannersContainer>
  );
});
